exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recurringRushDiv{\r\n    display: none;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n}\r\n\r\n.saveCardDiv{\r\n    display: none;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/place-holder/place-holder.component.css
// module id = ../../../../../src/app/place-holder/place-holder.component.css
// module chunks = main